/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.academics.per-year-requirements'},
});

const PerYearRequirementsItem = () => (
  <RouteLinkItem
    route="midas/settings/academics/per-year-requirements"
    title={messages.title}
  />
);

export default PerYearRequirementsItem;
